<template>
  <vue-swing
    @throwout="throwout"
    :config="config"
    class="swing-container"
  >
    <CardsGameCard
      v-for="(card, i) in cards"
      :key="i"
      :title="$localized(card, 'question')"
      :pic="card.pic"
      class="game-card"
      :class="{ 'custom-elevation': isLastCard(i) }"
    />
  </vue-swing>
</template>

<style scoped>
.swing-container {
  max-width: 500px;
  width: 100%;
}

.game-card {
  /*display: none;*/
  opacity: 0;
}

.game-card:nth-last-child(2) {
  opacity: .24;
}

.game-card:last-child {
  opacity: 1;
}
</style>

<script>
import VueSwing from 'vue-swing';

import CardsGameCard from '@/components/games/cards/CardsGameCard.vue';

const OFFSET = 0.5;

export default {
  name: 'CardsSwiper',
  components: {
    CardsGameCard,
    VueSwing,
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    config: {
      allowedDirections: [
        VueSwing.Direction.LEFT,
        VueSwing.Direction.RIGHT,
      ],
      throwOutConfidence(xOffset, yOffset, element) {
        const xConfidence = Math.min(Math.abs(xOffset) / (element.offsetWidth * OFFSET), 1);
        const yConfidence = Math.min(Math.abs(yOffset) / (element.offsetHeight * OFFSET), 1);
        return Math.max(xConfidence, yConfidence);
      },
    },
  }),
  methods: {
    throwout(evt) {
      if (evt.throwDirection === VueSwing.Direction.RIGHT) {
        return this.$emit('yes', this.card);
      }

      return this.$emit('nope', this.card);
    },
    isLastCard(i) {
      return (i === (this.cards.length - 1));
    },
  },
};
</script>
